/**
 * Whether the case chat composer may send a new message.
 * Sending while the assistant is busy is allowed (stop-then-send, ordered by the controller);
 * only a send that is already in flight blocks a second submit.
 */
export function composerCanSend(opts: {
  hasText: boolean;
  activeCaseId: string | null | undefined;
  sendInFlight: boolean;
}): boolean {
  return !!opts.hasText && !!opts.activeCaseId && !opts.sendInFlight;
}
